import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    token : "u123456",
    userId  : null,
    loading : false,
    error   : null,
    mobileVerify: null,
    authRedirectPath: '/',
    userObject : {
        userID: localStorage.getItem('userId'),
        empID : localStorage.getItem('EmpId'),
        role: localStorage.getItem('UserRole'),
        CompanyId: localStorage.getItem('CompanyId'),
        userName: localStorage.getItem('userName'),
        EmployeeName: localStorage.getItem('userName'),
        Nationality: localStorage.getItem('nationality'),
        empGroupCode: localStorage.getItem('empGroupCode'),
        hiringDate: '02/11/2017',
        jobTitle: 'Business Executive',
        dept: 'HR Admin',
        ReportingTo : 'Siddiqkhan'
    },
    userPref : {
        dateFormat: "dd/MM/yyyy"  
    },
    userPosInfo: null,
    // The page this user belongs on, from their authentication response. Null
    // until a response arrives, and null again on logout, so the login page can
    // treat it changing as "a login just succeeded, go there" (see Login.js).
    defaultPage: null,
    userDetail : null,
    menuLists : [],
    roleLists : [],
    hrTeam: false,
    admin: false,
    selectedModule: null   // add this one field
}

const authStart = (state,action) =>{
    return updateObject(state,{error:null,loading:true,success:null})
}

const authSuccess = (state,action) =>{
    return updateObject(state,
        {
            token: action.token,
            userId : action.userId,
            hrTeam: action.hrTeam,
            admin: action.admin,
            loading : false,
            userObject : {
                userID: localStorage.getItem('userId'),
                empID : localStorage.getItem('EmpId'),
                role: localStorage.getItem('UserRole'),
                CompanyId: localStorage.getItem('CompanyId'),
                userName: localStorage.getItem('userName'),
                EmployeeName: localStorage.getItem('userName'),
                nationality: localStorage.getItem('nationality'),
                empGroupCode: localStorage.getItem('empGroupCode'),
                hiringDate: '02/11/2017',
                jobTitle: 'Business Executive',
                dept: 'HR Admin',
                ReportingTo : 'Siddiqkhan',
                defaultbranch: localStorage.getItem('defaultbranch'), 

            },
        })
}

const authFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const authLogout = (state, action) => {
    // defaultPage goes too, so the next login is a change again — signing back in
    // as the same user would otherwise set the identical value, and the login page
    // watches for it changing (see Login.componentDidUpdate).
    return updateObject(state,{token:null,userId:null,defaultPage:null})
}

const setAuthRedirectPath = (state, action) => {
    return updateObject(state,{authRedirectPath:action.path})
}

const menuStart = (state,action) =>{
    return updateObject(state,{error:null,loading:true,success:null})
}


const menuSuccess = (state, action) =>{
    return updateObject(state,{menuLists:action.list,loading:false,success:null})
}

const menuFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}

const roleStart = (state,action) =>{
    return updateObject(state,{error:null,loading:true,success:null})
}


const roleSuccess = (state, action) =>{
    return updateObject(state,{roleLists:action.list,loading:false,success:null})
}

const roleFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false,
            roleLists : []
        })
}


const userDetailsStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
        })
}
const userDetailsFail = (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            loading:false
        })
}
const userDetailsSuccess = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            userDetail : action.data

        })
}

export const authMobileVerificationStart = (state,action) => {
    return updateObject(state,
        {
            error:null,
            success:null,
            mobileVerify:action.code,
            loading:false
        })
}
const getUserPosInfo = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            userPosInfo : action.data,
            // Straight off the authentication response (the options the user
            // master offers are in DEFAULT_PAGE_OPTIONS in AddUser.js). Taken
            // from here rather than from localStorage, where setItem turns a
            // user with none configured into the string "null". The dashboard
            // stands in for exactly that case.
            defaultPage : (action.data && action.data.defaultpage) || '/dashboard'

        })
    }
    
    
    const setSelectedModule = (state, action) => {
        return updateObject(state, { selectedModule: action.module })
    }

const authReducer = ( state = initialState, action) =>{
    switch(action.type){
        case actionTypes.AUTH_START: return authStart(state,action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state,action);
        case actionTypes.AUTH_FAIL: return authFail(state,action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state,action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.MENU_START: return menuStart(state,action);
        case actionTypes.MENU_SUCCESS: return menuSuccess(state,action);
        case actionTypes.MENU_FAIL: return menuFail(state,action);
        case actionTypes.AUTH_MOBILE_VERIFICATION_START: return authMobileVerificationStart(state,action);
        case actionTypes.USER_DETAIL_START: return userDetailsStart(state,action);
        case actionTypes.USER_DETAIL_SUCCESS: return userDetailsSuccess(state,action);
        case actionTypes.USER_DETAIL_FAIL: return userDetailsFail(state,action);
        case actionTypes.USER_POS_INFO: return getUserPosInfo(state,action);
        case actionTypes.ROLE_START: return roleStart(state,action);
        case actionTypes.ROLE_SUCCESS: return roleSuccess(state,action);
        case actionTypes.ROLE_FAIL: return roleFail(state,action);
        case actionTypes.SET_SELECTED_MODULE: return setSelectedModule(state, action);
        default:
            return state;

    }
}


export default authReducer;




